import React from 'react';
import Slider from './slider';
import Button from './button';
import ImageFile from './imageFile';
import CodeView from './codeView';
import TextField from './textField';
import Style from './style.sass';
import { Rnd } from 'react-rnd';

const defaultState = {
  x: 0,
  y: 0,
  width: 80,
  height: 60,
  blur: 0,
  brightness: 100,
  contrast: 100,
  sepia: 0,
  grayscale: 0,
  invert: 0,
  saturate: 100,
  hueRotate: 0,
  opacity: 100,
}

export default class Filter extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      x: defaultState.x,
      y: defaultState.y,
      width: defaultState.width,
      height: defaultState.height,
      blur: 0,
      brightness: 100,
      contrast: 100,
      sepia: 0,
      grayscale: 0,
      invert: 0,
      saturate: 100,
      hueRotate: 0,
      opacity: 100,
      imageFile: './images/sample_image.jpg',
      class: 'filter'
    };
  }

  handleChangeWidth = e => {
    this.setState({
      width: e.target.value || 80,
    });
  }

  handleChangeHeight = e => {
    this.setState({
      height: e.target.value || 60,
    });
  }

  handleChangeBlur = e => {
    this.setState({
      blur: e.target.value || 0,
    });
  }

  handleChangeBrightness = e => {
    this.setState({
      brightness: e.target.value || 100,
    });
  }

  handleChangeContrast = e => {
    this.setState({
      contrast: e.target.value || 100,
    });
  }

  handleChangeSepia = e => {
    this.setState({
      sepia: e.target.value || 0,
    });
  }

  handleChangeGrayscale = e => {
    this.setState({
      grayscale: e.target.value || 0,
    });
  }

  handleChangeInvert = e => {
    this.setState({
      invert: e.target.value || 0,
    });
  }

  handleChangeSaturate = e => {
    this.setState({
      saturate: e.target.value || 100,
    });
  }

  handleChangeHueRotate = e => {
    this.setState({
      hueRotate: e.target.value || 0,
    });
  }

  handleChangeOpacity = e => {
    this.setState({
      opacity: e.target.value || 100,
    });
  }

  allReset = () => {
    this.setState({
      x: defaultState.x,
      y: defaultState.y,
      width: defaultState.width,
      height: defaultState.height,
      blur: 0,
      brightness: 100,
      contrast: 100,
      sepia: 0,
      grayscale: 0,
      invert: 0,
      saturate: 100,
      hueRotate: 0,
      opacity: 100,
    });
  }

  onFileChange = e => {
    const file = e.target.files[0];
    const imageFile = (window.URL || window.webkitURL).createObjectURL(file) || './images/sample_image.jpg';
    this.setState({
      imageFile: imageFile
    });
    const background = document.getElementById('background');
    background.style.backgroundImage = `url(${imageFile})`;
  }

  handleChangeClass = e => {
    this.setState({
      class: e.target.value,
    })
  }

  copyText = e => {
    e.target.select();
  }

  onDrag = (e, d) => {
    this.setState({ x: d.x, y: d.y });
  }

  onResize = (e, direction, ref, delta, position)=> {
    this.setState({
      width: ref.style.width,
      height: ref.style.height,
      ...position
    });
  }

  componentDidUpdate() {
    const filter = document.getElementById('filter');
    const blur = `blur(${this.state.blur}px)`;
    const brightness = `brightness(${this.state.brightness}%)`
    const contrast = `contrast(${this.state.contrast}%)`;
    const sepia = `sepia(${this.state.sepia}%)`
    const grayscale = `grayscale(${this.state.grayscale}%)`;
    const invert = `invert(${this.state.invert}%)`;
    const saturate = `saturate(${this.state.saturate}%)`;
    const hueRotate = `hue-rotate(${this.state.hueRotate}deg)`;
    const opacity = `opacity(${this.state.opacity}%)`;
    const value = blur + brightness + contrast + sepia + grayscale + invert + saturate + hueRotate + opacity;
    filter.style.backdropFilter = value;
    filter.style.webkitBackdropFilter = value;
  }

  render() {
    const width = this.state.width === 0 ? '' : `${this.state.width}`;
    const height = this.state.height === 0 ? '' : `${this.state.height}`;
    const blur = this.state.blur === 0 ? '' : ` blur(${this.state.blur}px)`;
    const brightness = this.state.brightness === 100 ? '' : ` brightness(${this.state.brightness}%)`
    const contrast = this.state.contrast === 100 ? '' : ` contrast(${this.state.contrast}%)`;
    const sepia = this.state.sepia === 0 ? '' : ` sepia(${this.state.sepia}%)`
    const grayscale = this.state.grayscale === 0 ? '' : ` grayscale(${this.state.grayscale}%)`;
    const invert = this.state.invert === 0 ? '' : ` invert(${this.state.invert}%)`;
    const saturate = this.state.saturate === 100 ? '' : ` saturate(${this.state.saturate}%)`;
    const hueRotate = this.state.hueRotate === 0 ? '' : ` hue-rotate(${this.state.hueRotate}deg)`;
    const opacity = this.state.opacity === 100 ? '' : ` opacity(${this.state.opacity}%)`;
    const value = blur + brightness + contrast + sepia + grayscale + invert + saturate + hueRotate + opacity;
    const renderCode = () => {
      if (blur || brightness || contrast || sepia || grayscale || invert || saturate || hueRotate || opacity) {
        return `.${this.state.class} {\n  backdrop-filter:${value};\n  -webkit-backdrop-filter:${value};\n}`;
      } else {
        return '';
      }
    }
    return(
      <React.Fragment>
        <section className={Style.Filter}>
          <section>
            <h1 className={Style.Filter__heading}>CSS画像エフェクター</h1>
            <div className='c-info u-mt-15 u-fs-s'>CSSのみで要素の背景に対し、ぼかしや色変化といったグラフィック効果をもたらすことができます。生成したコードはコピペしてご利用ください。また、画像以外でも、ご自身のwebサイトのどの部分に対しても適用可能です。※画像はイメージです。ご自身の画像に変更してお試し下さい。</div>
          </section>
          <section className={Style.Filter__body}>
            <section className={Style.Filter__image}>
              <ImageFile onChange={e => this.onFileChange(e)}/>
              <div className={Style.Filter__background} id='background'>
                <Rnd
                  id='filter'
                  className={Style.Filter__object}
                  size={{ width: `${this.state.width}%`, height: `${this.state.height}%` }}
                  position={{ x: this.state.x, y: this.state.y }}
                  bounds='parent'
                  onDrag={ this.onDrag }
                  onResize={ this.onResize }
                >
                  <p>backdrop-filter: {value || 'none'};</p>
                </Rnd>
              </div>
            </section>
            <section className={Style.Filter__controller}>
              <Slider label='ぼかし:' min='0' max='100' value={this.state.blur} unit='px' onChange={e => this.handleChangeBlur(e)}/>
              <Slider label='コントラスト:' min='0' max='500' value={this.state.contrast} unit='%' onChange={e => this.handleChangeContrast(e)}/>
              <Slider label='セピア:' min='0' max='100' value={this.state.sepia} unit='%' onChange={e => this.handleChangeSepia(e)}/>
              <Slider label='グレースケール:' min='0' max='100' value={this.state.grayscale} unit='%' onChange={e => this.handleChangeGrayscale(e)}/>
              <Slider label='明度:' min='0' max='500' value={this.state.brightness} unit='%' onChange={e => this.handleChangeBrightness(e)}/>
              <Slider label='彩度:' min='0' max='500' value={this.state.saturate} unit='%' onChange={e => this.handleChangeSaturate(e)}/>
              <Slider label='色相:' min='0' max='360' value={this.state.hueRotate} unit='deg' onChange={e => this.handleChangeHueRotate(e)}/>
              <Slider label='反転:' min='0' max='100' value={this.state.invert} unit='%' onChange={e => this.handleChangeInvert(e)}/>
              <Slider label='不透明度:' min='0' max='100' value={this.state.opacity} unit='%' onChange={e => this.handleChangeOpacity(e)}/>
              <Button text='全てリセット' onClick={this.allReset}/>
            </section>
          </section>
          <section className={Style.Filter__code}>
            <TextField className={Style.Filter__className} label='クラス名' value={this.state.class} onChange={e => this.handleChangeClass(e)}/>
            <CodeView value={renderCode()} onClick={e => this.copyText(e)}/>
          </section>
        </section>
      </React.Fragment>
    )
  }
}